"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.receiveFonts = exports.fetchFonts = exports.addFontFamilyToDOM = exports.addCustomFonts = exports.addCustomFont = exports.RECEIVE_FONTS = exports.ADD_FONTS = exports.ADD_FONT = void 0;
var _configuration = require("../../configuration");
var _Actions = require("../Actions");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var RECEIVE_FONTS = exports.RECEIVE_FONTS = 'RECEIVE_FONTS';
var ADD_FONT = exports.ADD_FONT = 'ADD_FONT';
var ADD_FONTS = exports.ADD_FONTS = 'ADD_FONTS';
var addFontFamilyToDOM = exports.addFontFamilyToDOM = function addFontFamilyToDOM(name, url, bold, italic) {
  var fontFaceProperties = ['font-family: "' + name + '";', 'src: url("' + url + '");'];
  if (bold) {
    fontFaceProperties.push('font-weight: bold;');
  }
  if (italic) {
    fontFaceProperties.push('font-style: italic;');
  }
  var style = document.createElement('style');
  style.appendChild(document.createTextNode('@font-face { ' + fontFaceProperties.join(' ') + ' }'));
  document.head.appendChild(style);
};
var receiveFonts = exports.receiveFonts = function receiveFonts(data) {
  return function (dispatch) {
    var host = (0, _configuration.getConf)('network.host');
    var fonts = [];
    var _iterator = _createForOfIteratorHelper(data),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var customFont = _step.value;
        var font = {
          name: customFont.name,
          family: customFont.name,
          regular: false,
          bold: false,
          italic: false,
          boldItalic: false,
          isDefault: customFont.isDefault
        };
        var fontFields = [{
          field: 'fileNameRegular',
          property: 'regular',
          bold: false,
          italic: false
        }, {
          field: 'fileNameBold',
          property: 'bold',
          bold: true,
          italic: false
        }, {
          field: 'fileNameItalic',
          property: 'italic',
          bold: false,
          italic: true
        }, {
          field: 'fileNameBoldItalic',
          property: 'boldItalic',
          bold: true,
          italic: true
        }];
        for (var _i = 0, _fontFields = fontFields; _i < _fontFields.length; _i++) {
          var fontField = _fontFields[_i];
          var fontPath = customFont[fontField.field];
          if (fontPath) {
            var fontUrl = host + fontPath;
            var urlFieldName = 'url' + fontField.property.charAt(0).toUpperCase() + fontField.property.slice(1);
            font[fontField.property] = true;
            font[urlFieldName] = fontUrl;
            addFontFamilyToDOM(font.family, fontUrl, fontField.bold, fontField.italic);
          }
        }
        fonts.push(font);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    dispatch({
      type: RECEIVE_FONTS,
      data: fonts
    });
  };
};
var fetchFonts = exports.fetchFonts = function fetchFonts() {
  return (0, _Actions.fetchDataAsync)('designer/fonts', receiveFonts);
};
var addCustomFont = exports.addCustomFont = function addCustomFont(customFont) {
  return {
    type: ADD_FONT,
    data: customFont
  };
};
var addCustomFonts = exports.addCustomFonts = function addCustomFonts(customFonts) {
  return {
    type: ADD_FONTS,
    data: customFonts
  };
};